import React, { useEffect } from "react";
import { PropTypes } from "prop-types";

const GoogleAccountsInitializer = ({ loggedOut, onCredentialResponse }) => {
  useEffect(
    () => {
      if (
        loggedOut &&
        window.google &&
        window.google.accounts &&
        typeof window.google.accounts.id.initialize === "function"
      ) {
        console.log("Initializing Google Accounts...");
        window.google.accounts.id.initialize({
          client_id: "962641865525-qk3eqej1shfi589ahq1enclp2i5soen0.apps.googleusercontent.com",
          callback: onCredentialResponse,
          itp_support: true,
          use_fedcm_for_prompt: true
        });
        window.google.accounts.id.prompt();
      } else if (window.google && window.google.account) {
        console.warn("Typo detected: 'window.google.account' found instead of 'accounts'");
      }
    },
    [loggedOut]
  );

  return <div />; // No UI for this component
};

GoogleAccountsInitializer.propTypes = {
  loggedOut: PropTypes.bool,
  onCredentialResponse: PropTypes.func
};
export default GoogleAccountsInitializer;
